"use client";

import dynamic from "next/dynamic";

export const CartDrawer = dynamic(() =>
  import("./cart-drawer").then((mod) => mod.CartDrawer)
);
